<template>
  <b-col md="12">
    <section class="comments">
      <p class="comments__title">Richieste speciali</p>
      <div class="comments__wrap">
        <p>
          La struttura potrebbe non soddisfare le richieste speciali, ma farà comunque il possibile per venire incontro alle tue esigenze.<br>
          Potrai sempre contattare la struttura per richieste speciali anche dopo la prenotazione.
        </p>
        <div class="comments_form">
          <p v-html="'<strong>Scrivi le tue richieste in inglese o in italiano.</strong> <span class=\'text--sm\'>(facoltativo)</span>'" />
          <b-form-textarea v-model="message" @input="handler_comments" no-resize rows="3" />
        </div>
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  inheritAttrs: false,
  name: 'comments',

  inject: ['comments_checker'],

  components: {
  },

  props: {
  },

  data() {
    return {
      message: '',
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
    handler_comments() {
      this.comments_checker(this.message)
    }
  },
}
</script>

<style lang="scss" scoped>

  .comments {
    margin-top: $grid-gutter-width*2;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 20px;
    }

    &__wrap {
      background-color: $white;
      padding: 20px;
      border-radius: 10px;
    }
  }

</style>